"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _helpers = require("@nettoken/helpers");

var _events = require("./events");

var _meta = require("./meta");

var _providers = require("./providers");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var skipSocketEvents = ['pusher:pong'];
/**
 * @param {object} event
 * @param {any} data
 */

var logEventIntoConsole = function logEventIntoConsole(event, data) {
  if (!isLoggableEvent(event)) return;
  console.log('👌', 'WebSocket', event, data);
};
/**
 * @param {string} event Incoming event type.
 */


var isLoggableEvent = function isLoggableEvent(event) {
  return !skipSocketEvents.includes(event);
};
/**
 * @param {object} socket
 * @param {boolean} connected
 */


var logConnectEvent = function logConnectEvent(socket, connected) {
  var socketId = (0, _meta.getSocketId)(socket);
  var time = new Date().toString();
  var emoji = connected ? '✅' : '🛑';
  console.log(emoji, 'WebSocket', socketId, time);
};
/**
 * Middleware for logging WebSocket events into browser console. Adds a custom
 * wrapper to the socket instance methods so we can capture the event flow
 * before it is dispatched.
 *
 * @param {object} socket Socket instance.
 */


var logger = function logger(socket) {
  var logConnection = function logConnection() {
    return logConnectEvent(socket, true);
  };

  if (_providers.WS_PROVIDER === _providers.WS_PUSHER) {
    socket.connection.bind('connected', logConnection);
    socket.bind_global(logEventIntoConsole);
  } else if (_providers.WS_PROVIDER === _providers.WS_SOCKET_IO) {
    socket.on(_events.WS_CONNECT, logConnection);
    var onevent = socket.onevent.bind(socket);

    socket.onevent = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var packet = args[0];

      var _packet$data = _slicedToArray(packet.data, 2),
          event = _packet$data[0],
          data = _packet$data[1];

      var parsed = (0, _helpers.safeJSONParse)(data) || '';
      logEventIntoConsole(event, parsed);
      return onevent.apply(void 0, args);
    };
  }

  var disconnect = socket.disconnect.bind(socket);

  socket.disconnect = function () {
    logConnectEvent(socket, false);
    return disconnect();
  };
};

var _default = logger;
exports.default = _default;